export default {
  costing_management: ['costing_management'],

  costing_assumption_driver_management: ['costing_assumption_driver_management'],
  costing_assumption_driver_edit: ['costing_assumption_driver_edit'],
  costing_assumption_driver_add: ['costing_assumption_driver_add'],
  costing_assumption_driver_delete: ['costing_assumption_driver_delete'],

  costing_assumption_management: ['costing_assumption_management'],
  costing_assumption_edit: ['costing_assumption_edit'],
  costing_assumption_add: ['costing_assumption_add'],
  costing_assumption_delete: ['costing_assumption_delete'],

  costing_costing_management: ['costing_costing_management'],
  costing_costing_edit: ['costing_costing_edit'],
  costing_costing_add: ['costing_costing_add'],
  costing_costing_delete: ['costing_costing_delete'],
  costing_costing_archive: ['costing_costing_archive'],
  costing_costing_restore: ['costing_costing_restore'],

  costing_gasoline_management: ['costing_gasoline_management'],
  costing_gasoline_edit: ['costing_gasoline_edit'],
  costing_gasoline_add: ['costing_gasoline_add'],
  costing_gasoline_delete: ['costing_gasoline_delete'],
  costing_gasoline_archive: ['costing_gasoline_archive'],
  costing_gasoline_restore: ['costing_gasoline_restore']
}
